import React from "react";
import {
  LuVideo,
  LuStethoscope,
  LuUserCheck,
  LuCalendar,
} from "react-icons/lu";

/**
 * Agenda / Calendar Category Definitions
 * Matching Figma design color scheme & badges
 */
export const AGENDA_CATEGORIES = {
  ALL: {
    id: "all",
    label: "All Types",
    filterLabel: "All Types",
    color: "#00BADA",
    bg: "rgba(0, 186, 218, 0.12)",
    border: "#00BADA",
  },
  EVENT: {
    id: "event",
    label: "Event",
    filterLabel: "Events",
    color: "#188C2F",
    bg: "rgba(24, 140, 47, 0.12)",
    border: "#188C2F",
    badgeBg: "#E3F1E6",
  },
  WEBINAR: {
    id: "webinar",
    label: "Webinar",
    filterLabel: "Webinars",
    color: "#4117E8",
    bg: "rgba(65, 23, 232, 0.12)",
    border: "#4117E8",
    badgeBg: "rgba(65, 23, 232, 0.12)",
  },
  CLINICAL_SESSION: {
    id: "clinical_session",
    label: "Clinical Session",
    filterLabel: "Clinical Sessions",
    color: "#3165E5",
    bg: "rgba(49, 101, 229, 0.12)",
    border: "#3165E5",
    badgeBg: "rgba(49, 101, 229, 0.12)",
  },
  MENTORSHIP: {
    id: "mentorship",
    label: "Mentorship",
    filterLabel: "Mentorships",
    color: "#803F1C",
    bg: "rgba(128, 63, 28, 0.12)",
    border: "#803F1C",
    badgeBg: "rgba(128, 63, 28, 0.12)",
  },
};

export const AGENDA_CATEGORY_LIST = Object.values(AGENDA_CATEGORIES);

/**
 * Filter list specifically for Explore tab view
 */
export const EXPLORE_CATEGORY_LIST = [
  { id: "all", label: "All Types", filterLabel: "All Types" },
  { id: "event", label: "Events", filterLabel: "Events" },
  { id: "webinar", label: "Webinars", filterLabel: "Webinars" },
];

/**
 * Day name headers for Agenda Calendar View (Monday-start)
 */
export const CALENDAR_DAY_NAMES = ["MON", "TUE", "WED", "THUR", "FRI", "SAT", "SUN"];

/**
 * Maximum event lane count per day cell before '+X more' badge
 */
export const MAX_VISIBLE_CALENDAR_LANES = 2;

/**
 * Default category list for creating sessions / events
 */
export const DEFAULT_CATEGORIES = [
  "Ophthalmology",
  "Cornea & Ocular Surface",
  "Refractive Surgery",
  "Glaucoma",
  "Medical Retina & Vitreoretinal",
  "Pediatric Ophthalmology & Strabismus",
  "Neuro-Ophthalmology",
  "Cataract & Anterior Segment",
  "Oculoplastics & Orbit",
  "Uveitis & Ocular Immunology",
];

/**
 * Event form select options
 */
export const AVAILABILITY_OPTIONS = ["Online", "Offline", "Online & Offline"];
export const RECURRENCE_OPTIONS = ["One Time", "Daily", "Weekly"];

/**
 * Add Question question types
 */
export const QUESTION_TYPES = [
  "Short Answer",
  "Long Answer",
  "Multiple Choice",
  "Yes/No",
  "Photo",
  "Video",
  "Checklist",
];

/**
 * Returns React icon for category type
 */
export const getCategoryIcon = (type, size = 14) => {
  switch (type) {
    case "webinar":
      return React.createElement(LuVideo, { size });
    case "clinical_session":
      return React.createElement(LuStethoscope, { size });
    case "mentorship":
      return React.createElement(LuUserCheck, { size });
    case "event":
    default:
      return React.createElement(LuCalendar, { size });
  }
};

/**
 * Returns display label for category type
 */
export const getCategoryLabel = (type, uppercase = false, isSidebar = false) => {
  let label = "Event";
  switch (type) {
    case "webinar":
      label = "Webinar";
      break;
    case "clinical_session":
      label = isSidebar ? "Session" : "Clinical Session";
      break;
    case "mentorship":
      label = "Mentorship";
      break;
    case "event":
    default:
      label = "Event";
      break;
  }
  return uppercase ? label.toUpperCase() : label;
};

/**
 * Sidebar promotional card configuration
 */
export const DEFAULT_SIDEBAR_PROMO = {
  badge: "Connecting doctors",
  title: "Innovation in every scan. Precision in every detail.",
  description: "Discover next-generation imaging solution for better outcomes.",
  ctaText: "Explore Now",
  ctaLink: "#",
};
